import { Flex } from '@chakra-ui/react';

import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { HighlightCell } from '../components/HighlightCell';

interface IColumnKeywordData {
  query?: string;
}

export const ColumnKeyword: ColumnHelperMethodType<IColumnKeywordData> = (
  columnHelper,
  data,
) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'caption',
    cell: ({ row }) => (
      <HighlightCell query={data?.query ?? ''} justifyContent="flex-start">
        {row.original.caption ?? ''}
      </HighlightCell>
    ),
    header: () => (
      <Flex marginX={-5} justifyContent="flex-start">
        Keyword
      </Flex>
    ),
  });
